import { MutationDefinition } from '@reduxjs/toolkit/query'

import { baseQueryWithNotifications } from '@redux/api/config'

import { URLS } from '@constants'
import { ActionRow, GETEntity } from '@types'

import { fetchTooltipConfigsFromActions } from './fetchTooltipConfigsFromActions'

type FetchTimelineConfigFn = MutationDefinition<
  number | string,
  typeof baseQueryWithNotifications,
  string,
  GETEntity,
  'commonApi'
>['queryFn']

export const fetchEnrichedEntityConfigById: NonNullable<FetchTimelineConfigFn> = async (
  id,
  api,
  _,
  baseQuery
) => {
  const queryResult = await baseQuery({
    url: URLS.FRONT_CFG + `/view/id/${id}`,
    method: 'GET',
  })

  if (queryResult.error) {
    return { error: queryResult.error }
  }

  const configData = queryResult.data as GETEntity

  const tooltips = await fetchTooltipConfigsFromActions({ actions: configData.actions || [], api })

  const enrichActions = (actions?: ActionRow[]) => {
    return actions?.map(action => {
      if (action.objectTooltipId && tooltips.has(action.objectTooltipId)) {
        return {
          ...action,
          tooltip: tooltips.get(action.objectTooltipId),
        }
      }

      return action
    })
  }

  return {
    data: {
      ...configData,
      actions: enrichActions(configData.actions),
    },
  }
}
